module.exports = __webpack_public_path__ + "img/sdg_icon_07.ad82e838.png";